// src/services/settingsService.js
import api from './api';

export const createCustomField = (data) => {
    return api.post('/settings/custom-fields', data);
};

export const getCustomFields = () => {
    return api.get('/settings/custom-fields');
};
